import React, { Component } from 'react';
import './Partner.Module.scss';
import {connect} from 'react-redux';

import indexPartner from 'actions/partner/index';

const mapStateToProps = (state, props) => {
    return {
        blocks: state.block.entities,
        partners: state.partner.entities,
    };
};

const mapDispatchToProps = {
    indexPartner
};



class Partner extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
        }
        this.hoverOn    = this.hoverOn.bind(this);
        this.hoverOff    = this.hoverOff.bind(this);
    }
    componentDidMount(){
        this.props.indexPartner()
    }
    
    hoverOn(){
        this.setState({ hover: true})
    }
    hoverOff(){
        this.setState({ hover: false})
    }

    render() {
        let {item} = this.props
        return (
            <a
                onMouseEnter={this.hoverOn} onMouseLeave={this.hoverOff}
                href={`${item.link}`} target='_blank' styleName='partner'
                style={{
                    backgroundImage:`${(this.state.hover && item.image_hover) ? `url(/storage/${item.image_hover})` : `url(/storage/${item.image})`}`, 
                }}
            ></a>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Partner);